type FlavorRequirements = {
  memory_mb: number;
  root_gb: number;
}

type BootSourceRequirements = {
  min_ram: number;
  min_disk: number;
}

export const isFlavorCompatibleWithBootSource = (
  flavor: FlavorRequirements,
  bootSource?: BootSourceRequirements | null,
) => !bootSource || (
  flavor.memory_mb >= bootSource.min_ram &&
  flavor.root_gb >= bootSource.min_disk
)
